/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateIamRoleRequest
 */
export interface UpdateIamRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateIamRoleRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateIamRoleRequest
     */
    roleName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateIamRoleRequest
     */
    roleDescription?: string;
}

export function UpdateIamRoleRequestFromJSON(json: any): UpdateIamRoleRequest {
    return UpdateIamRoleRequestFromJSONTyped(json, false);
}

export function UpdateIamRoleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateIamRoleRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'roleName': !exists(json, 'role_name') ? undefined : json['role_name'],
        'roleDescription': !exists(json, 'role_description') ? undefined : json['role_description'],
    };
}

export function UpdateIamRoleRequestToJSON(value?: UpdateIamRoleRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'role_name': value.roleName,
        'role_description': value.roleDescription,
    };
}


